import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  question: '¿Realmente funciona en 3 días?',
  answer: 'Sí, si se sigue el protocolo de inmunidad al pañal sin excepciones.'
}, {
  question: '¿Qué pasa con las siestas?',
  answer: 'La guía incluye una estrategia específica para periodos de sueño.'
}, {
  question: '¿Necesito comprar equipos caros?',
  answer: 'No, solo un potty básico y muchos líquidos.'
}, {
  question: '¿Y si mi hijo es muy terco?',
  answer: 'El método usa la biología, no la voluntad, para crear el hábito.'
}, {
  question: '¿Funciona para niñas y niños?',
  answer: 'Absolutamente, el proceso neurológico es el mismo.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="bg-white py-14 px-4" data-id="element-24">
      <div className="max-w-3xl mx-auto" data-id="element-25">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} className="text-center mb-10" data-id="element-26">
          <h2 className="text-3xl md:text-4xl font-black text-dark-teal mb-4" data-id="element-27">
            Preguntas Frecuentes
          </h2>
        </motion.div>

        <div className="space-y-3" data-id="element-28">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="border border-gray-200 rounded-2xl overflow-hidden bg-cream/30" data-id="element-29">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full flex items-center justify-between p-5 text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-coral focus-visible:ring-inset" aria-expanded={openIndex === index} data-id="element-30">
                <span className="text-lg font-bold text-dark-teal pr-4" data-id="element-31">
                  {faq.question}
                </span>
                <ChevronDown className={`w-6 h-6 text-coral shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-32" />
              </button>

              <AnimatePresence data-id="element-33">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3,
              ease: 'easeInOut'
            }} data-id="element-34">
                    <div className="p-5 pt-0 text-gray-700 text-lg border-t border-gray-100" data-id="element-35">
                      {faq.answer}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}